import './App.css';
import AuthenticationEnhanced from './AuthEnhanced';

function App() {
  const currentProject= "PICKSTONE-001";
  return (
    <AuthenticationEnhanced project={currentProject}/>
  );
}

export default App;
